(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabs() {
      document.querySelectorAll('[data-cc-tabs]').forEach(function (tabs) {
        if (tabs.dataset.ccBound === '1') return;
        tabs.dataset.ccBound = '1';
        var tabBtns = tabs.querySelectorAll('.cc-tab');
        var panels = tabs.querySelectorAll('.cc-panel');
        tabBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.hasAttribute('data-cc-anchor')) {
              var el = document.getElementById('shopify-section-cc_certifications_band') || document.querySelector('.cc-certs');
              if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            var key = btn.getAttribute('data-cc-tab');
            tabBtns.forEach(function (b) {
              b.classList.remove('is-active');
              b.setAttribute('aria-selected', 'false');
            });
            btn.classList.add('is-active');
            btn.setAttribute('aria-selected', 'true');
            panels.forEach(function (p) {
              p.classList.toggle('is-active', p.getAttribute('data-cc-panel') === key);
            });
          });
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTabs);
    } else {
      initTabs();
    }
    document.addEventListener('shopify:section:load', initTabs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
